//import Libraries
import React, {Component} from 'react';
import {storageRef} from '../../../firebase';

//import Components

//import Styles
import './GreenHouse.css';

class GreenHouseImage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            url : ''
        }
    }

    componentDidMount(){
        this.loadImageFromStorage();
    }

    loadImageFromStorage = () => {
        this.setState({
            url : ''
        })
        storageRef.child(`case_images/${this.props.obj.id}.jpg`).getDownloadURL()
            .then((url) => {
                this.setState((prevState) => ({
                    url
                }))
            })
            .catch(e => {
            })
    }

    render() {
        return (
            <div className="ImageHolder">
                <div className="TextBox">
                    <h1>{this.props.obj.title[this.props.universal.language]}</h1>
                    <p>{this.props.obj.content[this.props.universal.language]}</p>
                </div>
                <img src={this.state.url}
                    key={this.props.idx} className="SliderImage" alt="" />
            </div>
        )
    }
}

export default GreenHouseImage;


// WEBPACK FOOTER //
// ./src/pages/Home/GreenHouse/GreenHouseImage.js